import { Book } from '@api/types.generated';

import { createBook, deleteBook, fetchBookList, updateBook } from './book.actions';
import { createReducer } from '../../../frontendUtils';
import {
  deleteArrayItemAfterAsyncCall,
  getArrayAfterAsyncCall,
  getArrayAfterAsyncCreateCall,
  updateArrayItemAfterAsyncCall,
} from '../../../frontendUtils/redux/reducers';

export type BookState = Book[];
export const initialState: BookState = [];

const bookReducer = createReducer(initialState, {
  [fetchBookList.done.type]: (state, action) => getArrayAfterAsyncCall(state, action),
  [createBook.done.type]: (state, action) => getArrayAfterAsyncCreateCall(state, action),
  [updateBook.done.type]: (state, action) => updateArrayItemAfterAsyncCall(state, action),
  [deleteBook.done.type]: (state, action) => deleteArrayItemAfterAsyncCall(state, action),
});

export default bookReducer;
